import {
  ElectricityBillingSettingResponseDto,
  ResidenceProfileResponseDto,
  UpdateElectricityBillingReq,
  UpdateResidenceProfileReq,
} from './setting.dto';
import { ElectricityBillingSetting, ResidenceProfile } from './setting.model';

export function buildProfileData(
  api: ResidenceProfileResponseDto,
): ResidenceProfile {
  return {
    nameTh: api.name,
    nameEn: api.name_en,
    companyCode: api.company_code,
    initial: api.initial,
    addressTh: api.address,
    addressEn: api.address_en,
    provinceTh: api.province,
    provinceEn: api.province_en,
    districtTh: api.district,
    districtEn: api.district_en,
    subDistrictTh: api.sub_district,
    subDistrictEn: api.sub_district_en,
    postalCode: api.postal_code,
    phone: api.tel,
    taxId: api.tax_id,
  };
}

export function buildBillingData(
  api: ElectricityBillingSettingResponseDto,
): ElectricityBillingSetting {
  return {
    billingCycleDay: api.billing_schedule_date,
    electricityRate: api.energy_unit_cost,
    onPeakRate: api.on_peak_energy_unit_cost,
    offPeakRate: api.off_peak_energy_unit_cost,
    unit: 'THB / kWh.',
  };
}

export function mapResidenceProfileModelToUpdateReq(
  model: ResidenceProfile,
): UpdateResidenceProfileReq {
  return {
    name: model.nameTh,
    name_en: model.nameEn,

    company_code: model.companyCode,
    initial: model.initial,

    address: model.addressTh,
    address_en: model.addressEn,

    province: model.provinceTh,
    province_en: model.provinceEn,

    district: model.districtTh,
    district_en: model.districtEn,

    sub_district: model.subDistrictTh,
    sub_district_en: model.subDistrictEn,

    postal_code: model.postalCode?.trim(),

    tel: model.phone,
    tax_id: model.taxId,
  };
}

export const mapBillingModelToUpdateReq = (
  m: ElectricityBillingSetting,
): UpdateElectricityBillingReq => ({
  billing_schedule_date: Number(m.billingCycleDay ?? 1),
  energy_unit_cost: Number(m.electricityRate ?? 0),
  on_peak_energy_unit_cost: Number(m.onPeakRate ?? 1),
  off_peak_energy_unit_cost: Number(m.offPeakRate ?? 0),
});
